import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

class LibraryBaseReq extends BaseReq {
  name: string = ""; // 材料名称
  model: string = ""; // 规格型号
  materialCategoryId: string | undefined = undefined; // 所属分类ID
  unitId: string | undefined = undefined; // 结算单位ID
  materialCategoryBrandId: string | undefined = undefined; // 品牌ID
  materialCategoryBrandName: string | undefined = undefined; // 品牌name
  remark: string = ""; // 备注
  costPrice: number = 0; // 预算成本价
  salesPrice: number = 0; // 市场销售价
  fileList: FileRecord[] = []; //附件
  enable: boolean = true; //启用禁用
}
enum UploadStatus {
  READY = "READY",
  UPLOADING = "UPLOADING",
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}
class FileRecord extends BaseReq {
  uid: string = "";
  name: string = "";
  url: string = "";
  size: number = 0;
  suffix: string = "";
  status: UploadStatus = UploadStatus.READY;
}
export class Brand extends BaseReq {
  id: string = "";
  name: string = "";
}
export class LibraryReq extends LibraryBaseReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
  brandList: Brand[] = [];
}

export class LibraryPageReq extends PaginationReq {
  name: string | undefined = undefined; // 材料名称
  model: string | undefined = undefined; // 规格型号
  materialCategoryId: string | undefined = undefined; // 材料分类
  enable: boolean | undefined = undefined;
  size: number = 10;
  remark: string = ""; // 备注
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class LibraryListRecord extends UpdaterResp {
  id: string = "";
  name: string = ""; // 材料名称
  model: string = ""; // 规格型号
  enable: boolean = false; // 启用状态
  materialCategoryId: string = ""; // 所属分类ID
  materialCategoryName: string = ""; // 所属分类名称
  unitId: string = ""; // 结算单位ID
  unitName: string = ""; // 结算单位名称
  materialCategoryBrandId: string = ""; // 品牌ID
  materialCategoryBrandName: string = ""; // 品牌名称
  remark: string = ""; // 备注
  costPrice: number = 0; // 预算成本价
  salesPrice: number = 0; // 市场销售价
}

export class LibraryPageResp extends PaginationResp<LibraryListRecord> {}

export class LibraryDetailResp extends UpdaterResp {
  name: string = ""; // 材料名称
  model: string = ""; // 规格型号
  materialCategoryId: string = ""; // 所属分类ID
  materialCategoryName: string = ""; // 所属分类名称
  unitId: string = ""; // 结算单位ID
  unitName: string = ""; // 结算单位名称
  materialCategoryBrandId: string = ""; // 品牌ID
  materialCategoryBrandName: string = ""; // 品牌名称
  remark: string = ""; // 备注
  costPrice: number = 0; // 预算成本价
  salesPrice: number = 0; // 市场销售价
}
